import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import React from 'react';

interface IconWrapperProps extends BoxProps {
  icon?: React.ElementType;
  iconSize?: number;
}

export const IconWrapper: React.FC<IconWrapperProps> = ({
  children,
  icon,
  bg = 'light-gray-1',
  iconSize = 16,
  p = 2,
  ...rest
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      rounded="full"
      p={p}
      bg={bg}
      {...rest}
    >
      {children
        ? children
        : icon && React.createElement(icon, { width: iconSize, height: iconSize })}
    </Box>
  );
};
